/** Returns true if s is enum of type T. NOTE: works only with string enums, not number-based enums!
 * Usage: isSomeEnum(MyEnumType)(enumObject)
 * Example: isSomeEnum(ModelVisibility)(visibility)
 * 
 * Source: https://stackoverflow.com/a/58278753
 */
export const isSomeEnum = <T extends { [s: string]: unknown }>(e: T) => (token: unknown): token is T[keyof T] => Object.values(e).includes(token as T[keyof T]);
